import Box from '@mui/material/Box';

import { Scrollbar } from 'src/components/scrollbar';
import { Lightbox, useLightBox } from 'src/components/lightbox';

import { ChatMessageItem } from './chat-message-item';
import { useMessagesScroll } from '../hooks/use-messages-scroll';

// ----------------------------------------------------------------------
/** @type {any} */
const ScrollbarAny = Scrollbar;
/** @type {any} */
const LightboxAny = Lightbox;

export function ChatMessageList({ messages = [], participants, loading, onFeedback }) {
  const { messagesEndRef } = useMessagesScroll(messages);

  const slides = messages
    .filter((message) => message.contentType === 'image')
    .map((message) => ({ src: message.body }));

  const lightbox = useLightBox(slides);

  void loading;

  return (
    <>
      <ScrollbarAny
        ref={messagesEndRef}
        sx={{
          px: { xs: 1.5, md: 4 },
          pt: { xs: 2, md: 4 },
          pb: { xs: 2, md: 4 },
          flex: '1 1 auto',
        }}
      >
        <Box
          data-chat-print="messages"
          sx={{
            width: '100%',
            maxWidth: 880,
            mx: 'auto',
            px: { xs: 0, md: 0.5 },
          }}
        >
          {messages.map((message) => (
            <ChatMessageItem
              key={message.id}
              message={message}
              participants={participants}
              onOpenLightbox={() => lightbox.onOpen(message.body)}
              onFeedback={onFeedback}
            />
          ))}
        </Box>
      </ScrollbarAny>

      <LightboxAny
        slides={slides}
        open={lightbox.open}
        close={lightbox.onClose}
        index={lightbox.selected}
      />
    </>
  );
}
